import {useCallback, useEffect, useRef, useState} from "react";

export default function useCopyToClipboard() {
    const [copied, setCopied] = useState(false);
    const [copiedId, setCopiedId] = useState(null);
    const timerRef = useRef(null);

    const copyFn = useCallback(async (text, id = null, duration = 3000) => {
        if (!text) return;

        try {
            await navigator.clipboard.writeText(text);

            // Сбрасываем предыдущий таймер, если был
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }

            setCopied(true);
            setCopiedId(id);

            timerRef.current = setTimeout(() => {
                setCopied(false);
                setCopiedId(null);
            }, duration);
        } catch (e) {
            console.error("Ошибка копирования:", e);
        }
    }, []);

    // Очистка таймера при размонтировании
    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);

    return {copied, copiedId, copyFn};
}
